import React from 'react'
import { generatePath, useParams } from 'react-router-dom'

import { ActionStrip, Card } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { useWebView } from 'hooks/useWebView'
import { routes } from 'router/routes'
import { style } from 'theme'

import { useGetEarlyFlow } from '../hooks/useGetEarlyFlow'

const remoteStringKeys = [
  'early.recurring.investment_disclosure1',
  'early.recurring.investment_disclosure2.1variable',
  'early.recurring.investment_disclosure3',
  'early.recurring.investment_disclosure4',
  'early.recurring.investment_disclosure5',
  'early.recurring.investment_disclosure6',
  'early.recurring.investment_disclosure7',
]

const StyledCard = styled<{ isWebView: boolean }>(Card)`
  border-radius: ${style((theme) => theme.styles.borderRadius)};
  color: ${style((theme) => theme.colors.slate)};
  overflow: hidden;
  max-width: 800px;
  margin: 0 auto;
  padding: 30px;
`

const Disclosure = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  white-space: pre-wrap;

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    text-align: center;
  }
`

const InvestmentDisclosure = () => {
  const routeParameters = useParams()
  const { isWebView } = useWebView()
  const { getRemoteString } = useRemoteStrings()
  const { flow } = useGetEarlyFlow()

  const disclosure = remoteStringKeys
    .map((key) => {
      if (key === 'early.recurring.investment_disclosure2.1variable') {
        return getRemoteString({
          key,
          variables: ['8'],
        })
      }

      return getRemoteString({ key })
    })
    .join('\n\n')

  return (
    <>
      {!isWebView && (
        <ActionStrip
          maxWidth={800}
          backOverride={`${generatePath(routes.early.recurringPotential, {
            beneficiaryId: routeParameters.beneficiaryId,
          })}?flow=${flow}`}
          title="Important Disclosures & Information"
          customTitleStyle="font-size: 14px;"
        />
      )}
      <StyledCard isWebView={isWebView}>
        <Disclosure>{disclosure}</Disclosure>
      </StyledCard>
    </>
  )
}

export default InvestmentDisclosure
